import { PayloadAction } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import React, { ReactNode } from 'react'
import { ErrorPayload } from '../actions/globalActions'
import * as global from '../actions/globalActions'

interface ValidationErrors {
  [key: string]: string[]
}

interface ErrorResponse {
  errors?: ValidationErrors
}

class ErrorMessageService {
  private toAxiosError(e: unknown): AxiosError<ErrorResponse> | undefined {
    if (typeof e !== 'object' || e === null) {
      return undefined
    }

    const candidate = e as AxiosError<ErrorResponse> & { isAxiosError?: boolean }
    return candidate.isAxiosError === true ? candidate : undefined
  }

  noViewerRights(): PayloadAction<ErrorPayload, string> {
    return this.toErrorAction(
      undefined,
      <span>
        Use of the Customer Back Office is limited to employees with an access permission.
        <br />
        &nbsp;&nbsp;- If you are a CC agent and need access, contact your Team manager immediately.
        <br />
        &nbsp;&nbsp;- If you are not a CC agent, please request access via Service Desk with a clear reason on why you need
        access. Access will be granted on a case-by-case basis.
      </span>
    )
  }

  toErrorAction(
    e?: unknown,
    defaultError: ReactNode = 'An error has occurred. Please try again. If the error persists, please contact #cp-order-support via Slack.'
  ): PayloadAction<ErrorPayload, string> {
    const axiosError = this.toAxiosError(e)

    if (axiosError?.response?.data?.errors) {
      const errors = axiosError.response.data.errors
      const errorMessages = Object.entries(errors)
        .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
        .join('\n');
      return global.showError({
        httpResponse: axiosError?.response,
        defaultMessage: errorMessages
      });
    }

    return global.showError({
      httpResponse: axiosError?.response,
      defaultMessage: defaultError,
    });
  }
}

export const Errors = new ErrorMessageService()
